import { MapPin } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconMapPin12Line = createIcon(MapPin, 12, "Line");
export const IconMapPin16Line = createIcon(MapPin, 16, "Line");
export const IconMapPin20Line = createIcon(MapPin, 20, "Line");
export const IconMapPin24Line = createIcon(MapPin, 24, "Line");
export const IconMapPin32Line = createIcon(MapPin, 32, "Line");
export const IconMapPin48Line = createIcon(MapPin, 48, "Line");
export const IconMapPin64Line = createIcon(MapPin, 64, "Line");
